import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "26",
  height: "20",
  fill: "none"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#fff",
  "fill-opacity": ".9",
  d: "M22.042 1.68A21.2 21.2 0 0 0 16.668 0c-.236.413-.499.973-.683 1.413a20.3 20.3 0 0 0-5.953 0c-.184-.44-.46-1-.684-1.413-1.892.32-3.692.893-5.375 1.68C.57 6.773-.35 11.747.11 16.653 2.37 18.32 4.551 19.333 6.694 20c.526-.72.999-1.493 1.406-2.307a13.7 13.7 0 0 1-2.22-1.08c.184-.133.368-.28.538-.426 4.284 1.986 8.923 1.986 13.154 0 .184.146.355.293.539.426-.71.427-1.445.787-2.22 1.08A16.3 16.3 0 0 0 19.295 20a21.7 21.7 0 0 0 6.584-3.347c.565-5.68-.895-10.613-3.838-14.973M8.692 13.627c-1.288 0-2.34-1.187-2.34-2.64s1.026-2.64 2.34-2.64c1.3 0 2.365 1.186 2.338 2.64 0 1.453-1.038 2.64-2.338 2.64m8.633 0c-1.287 0-2.34-1.187-2.34-2.64s1.026-2.64 2.34-2.64c1.301 0 2.365 1.186 2.34 2.64 0 1.453-1.026 2.64-2.34 2.64"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }